<template lang="pug">
    include ../helpers/pug/mixins
    +b.rsl-services
        +e.UL.list
            +e.LI.item(
                v-for="service in servicesList"
                v-bind:key="service.title"
            )
                +e.A.link(
                    target='_blank'
                    rel='noopener'
                    v-bind:href="service.href"
                )
                    +e.SVG.icon(xmlns="http://www.w3.org/2000/svg")
                        title(v-if="service.title") {{ service.title }}
                        use(v-bind:xlink:href="service.icon" xmlns:xlink="http://www.w3.org/1999/xlink")
                    +e.B.title {{ service.title }}
</template>

<script>
export default {
    props: {
        /**
             * Принимает на вход объект иконок, которые потом
             * будут отображаться в компоненте. Сам обьект выглядит
             * следующим образом
             * @param {String} href - Ссылка для тега <a>
             * @param {String} title - Название иконки (ее описание)
             * @param {String} icon - Ссылка на id в свг-спрайте, для вывода в теге <use>
             *
             * @type {Array}
             */
        servicesList: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        }
    }
};
</script>

<style lang="sass" src="./rsl-services.sass"></style>
